export var varArrowColor = 'var(--_1x5hp1c0)';